const accordion = {
    accordionToggle: function () {
        var accordionBtns = document.querySelectorAll(".accordion");

        accordionBtns.forEach(function (btn, index) {
            var content = btn.nextElementSibling;

            // Generate unique ID for content panel if it doesn't have one
            if (!content.id) {
                content.id = 'accordion-panel-' + index;
            }
            btn.setAttribute('aria-controls', content.id);

            // Set initial state based on whether accordion starts open
            if (btn.classList.contains("is-open")) {
                content.style.maxHeight = content.scrollHeight + "px";
                content.setAttribute('aria-hidden', 'false');
                content.inert = false;
            } else {
                content.style.maxHeight = '0px';
                content.setAttribute('aria-hidden', 'true');
                content.inert = true;
            }

            btn.onclick = function () {
                this.classList.toggle("is-open");
                var panel = this.nextElementSibling;
                var isOpen = this.classList.contains("is-open");
                this.setAttribute('aria-expanded', isOpen);

                if (isOpen) {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                    panel.setAttribute('aria-hidden', 'false');
                    panel.inert = false;
                } else {
                    panel.style.maxHeight = '0px';
                    panel.setAttribute('aria-hidden', 'true');
                    panel.inert = true;
                }
            };
        });
    }
}

export default accordion;
